import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <div id="thirdPart">
      <div id="contact">
        <p>
          Email: <a href="mailto:ttgroupllc@yahoo.com">ttgroupllc@yahoo.com</a>
        </p>
        <p>
          Phone Number: <a href="tel:4257707900">425-770-7900</a>
        </p>
        <p>
          Facebook: <a href="https://www.facebook.com/tntgroupllc">T&T Group</a>
        </p>
      </div>
    </div>
  );
};
export default Footer;
